import React from 'react';
import { connect } from 'react-redux';
import withRouter from 'js/withRouter';
import Modal from 'components/Modal';

import { legacyInjectIntl } from 'js/wrapper/injectIntl';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';

import Loader from 'components/layout/Loader';

class ModalPrivacyPolicy extends React.Component {
  render() {
    const {
      intl: { messages },
      show,
      close,
      cmsPage,
      owner,
    } = this.props;

    let dataUrl = '/api/pages/privacypolicy.json?';
    if (owner) {
      dataUrl += 'owner=' + (owner.username || owner.id);
    }

    return (
      <Modal show={show} onHide={close} size="lg" className="full-width">
        <Modal.Header closeButton>
          <Modal.Title>{messages.privacy_policy}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Data dataName="cmsSystemPagePrivacyPolicy" url={dataUrl} data={cmsPage} />

          <div className="themed">
            {cmsPage.pending ? <Loader /> : <CmsPage data={cmsPage.data} doUpdateActiveCms={false} />}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
ModalPrivacyPolicy.defaultProps = {
  owner: null,
};

const mapStateToProps = state => {
  return {
    cmsPage: state.data.cmsSystemPagePrivacyPolicy,
  };
};

export default withRouter(legacyInjectIntl(connect(mapStateToProps)(ModalPrivacyPolicy)));
